module.exports = __webpack_public_path__ + "img/overview.80817f72.svg";